// Gift follow-up ownership card. Mirrors data-component="gift-followup".
// The follow-up stays with the primary account owner (Jamie Dorsey here)
// per the shared ownership model.
//
// TODO(runtime): hydrate owner from services/customer-ownership once the
// read endpoint lands. Shipment-watch logic lives in
// dist/account-workflows (operation.followup) and
// services/service-recovery.
import type { ReactNode } from 'react';
import { JAMIE } from '../../../data/mockData.js';

export function GiftFollowup(): ReactNode {
  return (
    <section className="gift-followup" data-component="gift-followup">
      <span className="mini-avatar">{JAMIE.initials}</span>
      <div>
        <strong>Jamie owns the follow-up</strong>
        <p>
          If the shipment changes or gift availability changes, review the attachment before
          fulfillment.
        </p>
      </div>
    </section>
  );
}
